export default class SmoothScroll {
  constructor() {
    this.smoothScrollTrigger = [...document.querySelectorAll('a[href^="#"]')];

    if(this.smoothScrollTrigger.length !== 0) {
      this.init();
    }
  }

  /**
   * 指定IDの要素へスムーススクロール
   * @param {string} targetId - スクロール先要素のID（#なし）
   * @param {string} [behavior='smooth'] - 'smooth' | 'auto'（初期表示のハッシュ用は 'auto' で位置合わせのみ）
   * @param {HTMLElement} [anchorEl] - クリックされたアンカー要素（追従ナビ内リンクのオフセット用）
   */
  scrollToTarget(targetId, behavior = 'smooth', anchorEl = null) {
    const targetElement = document.getElementById(targetId);
    if(!targetElement) return;

    const rect = targetElement.getBoundingClientRect().top;
    const offset = window.scrollY;
    const gap = this.getScrollGap(anchorEl);
    const target = rect + offset - gap;
    requestAnimationFrame(() => {
      window.scrollTo({
        top: target,
        behavior,
      });
    });
  }

  getHeaderGap() {
    const header = document.getElementById('js-header');
    let gap = 0;

    if (header) {
      const logo = header.querySelector('.l-header__logo_link');
      if (logo) {
        gap = logo.getBoundingClientRect().bottom;
      } else {
        gap = header.getBoundingClientRect().bottom;
      }
    }

    const hamburger = document.querySelector('.o-hamburger__box');
    if (hamburger) {
      gap = Math.max(gap, hamburger.getBoundingClientRect().bottom);
    }

    return gap;
  }

  // 追従ナビがある場合はその高さを控除する　なければ固定ヘッダー分を控除する
  getScrollGap(anchorEl) {
    const followGap = this.getFollowNavGap(anchorEl);
    if (followGap > 0) {
      return followGap;
    }
    return this.getHeaderGap();
  }

  //追従ナビ分のオフセット（PC・上部固定時のみ）
  getFollowNavGap(anchorEl) {
    const mq = window.matchMedia('(min-width: 768px)');
    //SPはgapは不要
    if (!mq.matches) {
      return 0;
    }

    const stickyTrigger = document.querySelector('.js-follow_trigger.is-sticky');
    if (stickyTrigger) {
      return stickyTrigger.getBoundingClientRect().bottom;
    }

    if (anchorEl) {
      const trigger = anchorEl.closest('.js-follow_trigger');
      if (trigger) {
        return trigger.offsetHeight;
      }
    }

    return 0;
  }

  init() {
    this.smoothScrollTrigger.forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const href = el.getAttribute('href');
        const targetId = href.replace('#', '');
        const targetElement = document.getElementById(targetId);

        if(!targetElement) return;

        this.scrollToTarget(targetId, 'smooth', el);
      });
    });

    // 直接ハッシュ付きで開いた場合も同じ位置に合わせる
    // パラメーターが含まれる場合はID部分だけを取り出す
    const hash = window.location.hash.slice(1).split('?')[0].split('&')[0];
    if(hash && document.getElementById(hash)) {
      const onReady = () => {
        this.scrollToTarget(hash, 'auto');
      };
      if(document.readyState === 'loading') {
        window.addEventListener('load', () => requestAnimationFrame(onReady));
      } else {
        requestAnimationFrame(onReady);
      }
    }
  }
}